import * as React from 'react';

import {Button} from '../button/button';
import {ButtonMover} from '../button-mover/button-mover';
import {EmptyStateLarge} from '../empty-states/empty-state-large';
import {Illustration} from '../illustrations/illustration';
import {Link} from '../link/link';

import styles from './error-state.module.css';

type Props = {
    errorMessage?: string | null | undefined;
    size?: 'big' | 'small';
};

export function ErrorState(props: Props) {
    const isSmall = props.size === 'small';

    return (
        <div className={styles.container}>
            <EmptyStateLarge
                title={props.errorMessage ? props.errorMessage : 'Oh no, something went wrong'}
                subtitle={
                    <div
                        className={
                            isSmall
                                ? styles['subtitle-container--small']
                                : styles['subtitle-container']
                        }
                    >
                        Please&nbsp;
                        <ButtonMover
                            size={isSmall ? 'normal' : 'xlarge'}
                            direction={['left', 'right', 'up', 'down']}
                        >
                            <Button
                                size={isSmall ? 'normal' : 'xlarge'}
                                variant='text-primary'
                                onClick={() => {
                                    location.reload();
                                }}
                            >
                                try again
                            </Button>
                        </ButtonMover>
                        &nbsp;or&nbsp;
                        <Link
                            size={isSmall ? 'normal' : 'big'}
                            href='https://www.nutshell.com/support'
                            variant='primary'
                        >
                            contact support.
                        </Link>
                    </div>
                }
                icon={
                    <div style={{width: isSmall ? '150px' : '284px'}}>
                        <Illustration src='plug-error-state' width='100%' height='100%' />
                    </div>
                }
            />
        </div>
    );
}
